var map = {
	"./community.svg": 5944,
	"./marketing.svg": 2455,
	"./nelson.svg": 5410,
	"./nelson_dp.svg": 5557,
	"./resources.svg": 6872,
	"./rmt.svg": 6922,
	"./tools.svg": 330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7841;